/**
 * @class SocialMediaCoreDomainNameStringAssets A collection of string assets that pertain to core domain names of social media sites
 */
 export class SocialMediaCoreDomainNameStringAssets {
    static Facebook: string = 'Facebook.com';
    static Gab: string = 'Gab.com';
    static Instagram: string = 'Instagram.com';
    static LinkedIn: string = 'LinkedIn.com';
    static Pinterest: string = 'Pinterest.com';
    static TikTok: string = 'TikTok.com';
    static TruthSocial: string = 'TruthSocial.com';
    static Twitter: string = 'Twitter.com';
    static X: string = 'X.com';
    static YouTubeRegular: string = 'YouTube.com';
    static YouTubeShortened: string = 'YouTu.be';
 }